
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/sub/cookies-info",
      function () {
        return require("private-next-pages/us/sub/cookies-info.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/sub/cookies-info"])
      });
    }
  